import { render, staticRenderFns } from "./base-evolution.vue?vue&type=template&id=33859cec&scoped=true"
import script from "./base-evolution.vue?vue&type=script&lang=js"
export * from "./base-evolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33859cec",
  null
  
)

export default component.exports